import { IMembers } from "../../interfaces/companyProfile/iMembers";
import { IMemberOrganisationCard } from "../../interfaces/iMemberOrganisationCard";

export class Members implements IMembers {
	engaged: IMemberOrganisationCard[];
	active: IMemberOrganisationCard[];
	alumni: IMemberOrganisationCard[];
	waitlisted: IMemberOrganisationCard[];

	constructor(members: IMembers = {} as IMembers) {
		this.engaged = members.engaged;
		this.active = members.active;
		this.alumni = members.alumni;
		this.waitlisted = members.waitlisted;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/companyProfile/members.ts